import type { SVGProps } from "react";

export function Ribbon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="8" r="4.8" />
      <path d="m8.5 12.2-3.5 8.8 7-3.7 7 3.7-3.5-8.8" />
    </svg>
  );
}
